import type { ShallowRef } from 'vue';

export type AdditionalValidatorOptions = JQueryValidation.ValidationOptions & {
    useValidatorDefaults?: false;
    ignoreReadonly?: boolean;
};

export type ValidateFormApi = {
    formElement: ShallowRef<HTMLFormElement | undefined>;
    validatorInstance: ShallowRef<JQueryValidation.Validator | undefined>;
    validateForm(): boolean;
    resetForm(ids?: string[]): void;
    reset(): void;
};

export function mapRules<const T extends Record<string, Record<string, unknown>>>(_rules: T) {
    return Object.fromEntries(
        Object.entries(_rules).map(([key, value]) => [key, { rules: value }]),
    ) as {
        [K in keyof T]: { rules: T[K] };
    };
}
